/**
 * QUICK ADD COLOR MEMORY SYSTEM - Shopify Store
 * VERSIONE FINALE - NO LOOP
 */

(function() {
  'use strict';

  let lastRestoredTime = 0;
  let isRestoring = false;
  let modalAlreadyRestored = false; // ✅ NUOVO: evita doppi restore

  // ============================================================
  // 1️⃣ SALVA COLORE QUANDO CLICCHI UN PIN
  // ============================================================
  
  document.addEventListener('click', function(e) {
    const swatch = e.target.closest('[data-color-value]');
    if (!swatch) return;

    const colorName = swatch.getAttribute('data-color-name');
    if (!colorName) return;

    console.log('🎨 PIN CLICCATO:', colorName);
    localStorage.setItem('annab_selectedColor', colorName);
    console.log('✅ Salvato:', colorName);
    
    // ✅ Reset il flag quando clicchi un nuovo pin
    modalAlreadyRestored = false;
  }, true);

  // ============================================================
  // 2️⃣ RIPRISTINA IL COLORE NEL MODAL (UNA SOLA VOLTA)
  // ============================================================
  
  function restoreColorInModal() {
    // ✅ Esci se already restored
    if (modalAlreadyRestored) return;
    
    const now = Date.now();
    if (now - lastRestoredTime < 500) return;
    if (isRestoring) return;
    
    isRestoring = true;
    lastRestoredTime = now;

    const savedColorName = localStorage.getItem('annab_selectedColor');
    console.log('🔍 Cercando colore salvato:', savedColorName);

    if (!savedColorName) {
      isRestoring = false;
      return;
    }

    const modalContent = document.getElementById('quick-add-modal-content');
    if (!modalContent) {
      isRestoring = false;
      return;
    }

    const colorInput = modalContent.querySelector(
      `input[type="radio"][value="${savedColorName}"]`
    );

    if (!colorInput) {
      console.log('❌ Input non trovato con value:', savedColorName);
      isRestoring = false;
      return;
    }

    console.log('✅ TROVATO! Selezionando:', savedColorName);
    
    colorInput.checked = true;
    colorInput.dispatchEvent(new Event('change', { bubbles: true }));
    colorInput.dispatchEvent(new Event('input', { bubbles: true }));
    
    const label = colorInput.closest('label');
    if (label) {
      label.click();
      console.log('✨ Colore ripristinato con successo!');
    }
    
    // ✅ Mark come restored
    modalAlreadyRestored = true;
    
    setTimeout(() => { isRestoring = false; }, 100);
  }

  // ============================================================
  // 3️⃣ MONITOR DEL MODAL CON DEBOUNCE
  // ============================================================
  
  let debounceTimer = null;

  const observeModalOpening = () => {
    const observer = new MutationObserver((mutations) => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        const modalContent = document.getElementById('quick-add-modal-content');
        if (modalContent && !modalAlreadyRestored) { // ✅ Aggiungi check
          console.log('🔔 Modal aperto! Ripristinando colore...');
          restoreColorInModal();
        }
      }, 200);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  // ============================================================
  // 4️⃣ INIT
  // ============================================================
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      console.log('🚀 Color Memory System inizializzato');
      observeModalOpening();
    });
  } else {
    observeModalOpening();
  }

})();
